import { Outlet } from "react-router-dom";

import { Otp } from "components";
import Login from "pages/Login/Login.Screen";
import useAuth from "helpers/hooks/useAuth";
import useOtp from "helpers/hooks/useOtp";
import NoActionForFiveMin from "components/BaseComponents/Timeout/NoActionForFiveMin";

const ProtectedRouter = () => {
  let isLogIn: boolean = useAuth();
  let isOtp = useOtp();

  const Placeholder = () => (isLogIn && !isOtp ? <Otp /> : <Login />);

  return isLogIn && isOtp ? (
    <NoActionForFiveMin>
      <Outlet />
    </NoActionForFiveMin>
  ) : (
    <Placeholder />
  );
};

export default ProtectedRouter;
